import { Illustration, Text, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { masterStateSelectedAdvisorSelector } from '../../../../../../../store/master/selector';

import { texts } from './constants';

export const NotFound: React.FC = () => {
  const masterAdvisorSelected = useRecoilValue(masterStateSelectedAdvisorSelector);

  const descriptionText = useBreakpointValue({
    base: masterAdvisorSelected ? texts.withAdvisorDescriptionBase : texts.defaultDescriptionBase,
    sm: masterAdvisorSelected ? texts.withAdvisorDescriptionSm : texts.defaultDescriptionSm,
  });

  return (
    <VStack space={Spacing['inline.quarck']} alignItems={'center'} py={Spacing['stack.huge']}>
      <Illustration name="NotFoundIllustration" testId="ilustration-not-found" />
      <Text fontSize="md" color="neutral.black" variant="semibold" mt={Spacing['inset.nano']}>
        {masterAdvisorSelected ? texts.withAdvisorTitle : texts.defaultTitle}
      </Text>

      <Text
        textAlign="center"
        color="neutral.black"
        variant="regular"
        fontSize="md"
        px={Spacing['inline.nano']}>
        {descriptionText}
      </Text>
    </VStack>
  );
};
